import { useEffect } from 'react';
import PropTypes from 'prop-types';
import AOS from 'aos';

// Components
import Container from '../../Core/Container';
import Link from '../../Core/Link';
import RichText, { fragment, all } from '../../Core/RichText';

import {
  Wrapper,
  Block,
  Content,
  Img,
  Body,
  CopyWrapper,
  Features,
  Footer,
} from './styles';

const CardFeatures = ({ data }) => {
  if (!data) return null;

  const { imageDam, header, bodyCopy, listOfFeatures, ctas, component } = data;

  const leftSideFeatures = listOfFeatures.slice(0, 4);
  const rightSideFeatures = listOfFeatures.slice(4, 8);

  useEffect(() => {
    AOS.init({ disable: 'mobile' });
  }, []);

  return (
    <Container>
      <Wrapper>
        <Block className="left">
          <Features className={`${component} left`} data={leftSideFeatures} />
        </Block>
        <Content>
          {imageDam && <Img src={imageDam} alt={imageDam.altText || ''} />}
          <Body className={component}>
            <RichText document={header} options={all} />
            {bodyCopy ? (
              <CopyWrapper>
                <RichText document={bodyCopy} />
              </CopyWrapper>
            ) : null}
            {ctas ? (
              <Footer>
                {ctas &&
                  ctas.map(cta => {
                    if (cta.hideFrench === true) return null;
                    return (
                      <Link key={cta.id} data={cta}>
                        <RichText document={cta.label} options={fragment} />
                      </Link>
                    );
                  })}
              </Footer>
            ) : null}
          </Body>
        </Content>
        <Block className="right">
          <Features className={`${component} right`} data={rightSideFeatures} />
        </Block>
      </Wrapper>
    </Container>
  );
};

CardFeatures.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default CardFeatures;
